import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ApprovalService } from './approval.service';
import { ConfirmWaitsNgService } from '../../services/mcp/actions/confirm-waits-ng.service';
import { OverlayConfirmationsNgService } from '../../services/mcp/actions/overlay-confirmations-ng.service';
import { getZavoBridge } from '../../services/mcp/zavo-bridge';
import { GlobalVariablesService } from '../../services/global-variables.service';
import { isLightScreen } from '../../studio-nav/screen-tone';

@Component({
  selector: 'app-approval-layer',
  imports: [CommonModule],
  templateUrl: './approval-layer.component.html',
  styleUrls: ['./approval-layer.component.scss'],
  host: { '[class.approval-dark]': 'dark' },
})
export class ApprovalLayerComponent implements OnInit {
  readonly approvalService = inject(ApprovalService);
  readonly overlayConfirmations = inject(OverlayConfirmationsNgService);
  private confirmWaits = inject(ConfirmWaitsNgService);
  showHistory = false;
  private router = inject(Router);
  private globals = inject(GlobalVariablesService);

  // The card sits on the editor's screen, so it takes the editor's light or dark tone, not the OS's.
  get dark(): boolean {
    return !isLightScreen(this.router.url, this.globals.pageThemeDark);
  }

  ngOnInit(): void {
    // Only the desktop app provides the bridge; in a normal browser the layer stays idle.
    const bridge = getZavoBridge();
    if (!bridge) return;

    // The id goes back with the answer so main can ignore an answer to an ask it no longer has open.
    bridge.onApprovalAsk((askId, ask) => {
      void this.approvalService.ask(ask, askId).then((answer) => bridge.answerApproval(askId, answer));
    });
    bridge.onApprovalCancel((askId) => {
      if (typeof askId === 'string') this.approvalService.cancelAsk(askId);
      else {
        this.approvalService.cancelConnectionAsks();
        this.confirmWaits.closeAll('the connection to Claude dropped');
      }
    });
  }

  toggleHistory(): void {
    this.showHistory = !this.showHistory;
  }
}
